"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1753))
 * @lastsynced 2026-10-29T13:51:23.393Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const Download = createSVGIcon(
  <path
    d="M.857 18v1.714a3.43 3.43 0 0 0 3.429 3.429h15.428a3.43 3.43 0 0 0 3.429-3.429V18m-6-7.714-5.143 6-5.143-6m5.143 6V.857"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "Download",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      id: "BCVNEI",
      defaultMessage: "Download",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    color: iconColor.primary,
    className: iconCls(),
  })
);
